export var CONTEXT_MENU_OPTIONS;
(function (CONTEXT_MENU_OPTIONS) {
    CONTEXT_MENU_OPTIONS["COPY"] = "copy";
    CONTEXT_MENU_OPTIONS["PASTE"] = "paste";
    CONTEXT_MENU_OPTIONS["CUSTOM_LOGIC"] = "custom_logic";
})(CONTEXT_MENU_OPTIONS || (CONTEXT_MENU_OPTIONS = {}));
var contextMenuSchema = function (actionSchema) { return [
    {
        id: 0,
        key: CONTEXT_MENU_OPTIONS.COPY,
        label: 'Copy',
        action: actionSchema === null || actionSchema === void 0 ? void 0 : actionSchema[CONTEXT_MENU_OPTIONS.COPY],
    },
    {
        id: 1,
        key: CONTEXT_MENU_OPTIONS.PASTE,
        label: 'Paste',
        action: actionSchema === null || actionSchema === void 0 ? void 0 : actionSchema[CONTEXT_MENU_OPTIONS.PASTE],
    },
    {
        id: 2,
        key: CONTEXT_MENU_OPTIONS.CUSTOM_LOGIC,
        label: 'Create Custom Logic',
        action: actionSchema === null || actionSchema === void 0 ? void 0 : actionSchema[CONTEXT_MENU_OPTIONS.CUSTOM_LOGIC],
    },
]; };
export default contextMenuSchema;
